import { createStandaloneToast } from '@chakra-ui/react';

const { ToastContainer, toast } = createStandaloneToast();

export const showToast = toast;

export const showErrorToast = (error = '', title?: string) =>
  toast({
    title: title ?? 'Error!',
    description: error,
    status: 'error',
    duration: 9000,
    isClosable: true,
    position: 'top',
  });

export const showSuccessToast = (title: string, description?: string) =>
  toast({
    title,
    description,
    status: 'success',
    duration: 5000,
    isClosable: true,
    position: 'top',
  });

export default ToastContainer;
